import React, { useState } from "react";
import { Logo } from "../Assests/img/index";
import { NavLink, Route, Routes, useNavigate } from "react-router-dom";
import { isActiveStyles, isNotActiveStyles } from "../utils/styles";
import { FaCrown } from "react-icons/fa";
import { useStateValue } from "../Context/StateProvider";
import { getAuth } from "firebase/auth";
import { app } from "../config/Firebase.config";
import { motion } from "framer-motion";

const Header = () => {
  const [{ user }, dispatch] = useStateValue();
  const [isMenu, setisMenu] = useState(false);

  const navigate = useNavigate();

  const Logout = () => {
    const firebaseAuth = getAuth(app);
    firebaseAuth
      .signOut()
      .then(() => {
        window.localStorage.setItem("auth", "false");
      })
      .catch((e) => console.log(e));
    navigate("/login", { replace: true });
  };
  return (
    <header className="flex items-center w-full p-4 md:py-2 md:px-6">
      <NavLink to={"/"}>
        <img src={Logo} alt="logo" className=" w-16" />
      </NavLink>
      <ul className="flex  items-center justify-center ml-7">
        <li className="mx-5 text-lg">
          <NavLink
            to={"/Home"}
            className={({ isActive }) =>
              isActive ? isActiveStyles : isNotActiveStyles
            }
          >
            Home
          </NavLink>
        </li>
        <li className="mx-5 text-lg">
          <NavLink
            to={"/musics"}
            className={({ isActive }) =>
              isActive ? isActiveStyles : isNotActiveStyles
            }
          >
            musics
          </NavLink>
        </li>
        <li className="mx-5 text-lg">
          <NavLink
            to={"/Premium"}
            className={({ isActive }) =>
              isActive ? isActiveStyles : isNotActiveStyles
            }
          >
            Premium
          </NavLink>
        </li>
        <li className="mx-5 text-lg">
          <NavLink
            to={"/contact"}
            className={({ isActive }) =>
              isActive ? isActiveStyles : isNotActiveStyles
            }
          >
            Contact us
          </NavLink>
        </li>
      </ul>

      <div
        onMouseEnter={() => setisMenu(true)}
        onMouseLeave={() => setisMenu(false)}
        className="flex items-center ml-auto cursor-pointer gap-2 relative "
      >
        <img
          src={user?.user.imageUrl}
          className="w-12  h-12 min-w-[44px] object-contain rounded-full shadow-lg"
          alt=""
          referrerPolicy="no-referrer"
        />
        <div className="flex flex-col">
          <p className="text-textcolor text-lg hover:text-headingColor font-semibold">
            {user?.user?.name}
          </p>
          <p className="flex items-center gap-2 text-ss text-gray-500 font-normal">
            {" "}
            premium member
            <FaCrown className="text-sm -ml-1 text-yellow-500" />
          </p>
        </div>
        {isMenu && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            className="absolute z-10 flex flex-col  p-3 top-14 right-0 w-275 gap-2 bg-card shadow-lg rounded-lg backdrop-blur-sm "
          >
            <NavLink to={"/UserProfile"}>
              <p className="text-base text-textColor hover:font-semibold duration-150 translate-all ease-in-out">
                Profile
              </p>
            </NavLink>

            <p className="text-base text-textColor hover:font-semibold duration-150 translate-all ease-in-out">
              My Favorites
            </p>

            <hr />

            {user?.user.role === "admin" && (
              <>
                <NavLink to={"/dashboard/home"}>
                  <p className="text-base text-textColor hover:font-semibold duration-150 translate-all ease-in-out">
                    Dashboard
                  </p>
                </NavLink>
              </>
            )}

            <p
              className="text-base text-textColor hover:font-semibold duration-150 translate-all ease-in-out"
              onClick={Logout}
            >
              Sign out
            </p>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;
